module.exports = __webpack_public_path__ + "media/img/favicon-deed6ed00301f872aabdf1d72cbceb47.ico";